import { useRef, useState } from 'react';

import { Form, message } from 'antd'
import update from 'immutability-helper';
import Image from 'next/legacy/image'

import { getPayCurrenciesInfo } from '@api/index';
import { PRECISION8 } from '@constants/index';
import type { SelectProps } from '@element/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import { helper, I18n } from '@utils/index';
import { useAssetAccountMap0 } from '@widget/airdrop/hooks/useAssetAccountMap0';

import styles from './index.module.less';

type Iparams = {
  name: string;
}

type IList = {
  precision: number;
} & SelectProps['options'][number]

type Icache = {
  [key: string]: any;
}

const getMaxAvailable = (maxAvailable: number, available: number) => {
  if (!maxAvailable || !available) {
    return 0
  }
  return Math.max(Math.min(maxAvailable, available), 0)
}

export const useCoin = (params: Iparams) => {
  const { name } = params;
  const assetAccount = useAssetAccountMap0()
  const [options, setOptions] = useState([]);
  const [available, setAvailable] = useState(0);
  const cacheRef = useRef<Icache>({});
  const form = Form.useFormInstance()

  const updateOptions = (assetAccountList: any[]) => {
    const list: IList[] = assetAccountList
      .filter(item => item.hotMoney > 0)
      .sort((a, b) => b.usdMoney - a.usdMoney).map(item => ({
        label: item.coinCode,
        value: item.coinCode,
        picturePath: item.picturePath,
        precision: item.showKeepDecimalForCoin ?? PRECISION8,
        itemPrefix: (
          <div className={styles.image}>
            <Image
              src={item.picturePath}
              width={24}
              height={24}
              className='image_borderRadius_24'
              alt={item.coinCode} />
          </div>
        )
      }))
    setOptions(list);
    const value = form.getFieldValue(name)
    if (!value) {
      form.setFieldValue(name, list[0]?.value)
      form.setFieldValue('precision', list[0]?.precision);
      getAvailable({ coinCode: list[0]?.value as string, precision: list[0]?.precision })
    }
  }

  const getAvailable = async (params: { coinCode: string; precision: number; forceFetch?: boolean }) => {
    const { coinCode, precision, forceFetch } = params;
    if (!coinCode) return
    if (cacheRef.current?.[coinCode] && !forceFetch) {
      setAvailable(cacheRef.current[coinCode])
      return
    }
    try {
      const res = await getPayCurrenciesInfo({ coinCode })
      if (!res.success) {
        message.error(I18n.t(res.msgKey))
        return
      }
      const maxAvailable = getMaxAvailable(res.obj.maxAvailable, res.obj.available);
      const amount = helper.formatFixNumString(maxAvailable, precision || 8);
      cacheRef.current = update(cacheRef.current, {
        $merge: {
          [coinCode]: amount
        }
      })
      setAvailable(amount);
    } catch (error) {
      console.log('line 91', error)
    }
  }

  useIsomorphicLayoutEffect(() => {
    updateOptions(assetAccount)
  }, [assetAccount])
  return {
    options,
    available,
    getAvailable
  }
}
